<template>
  <SvoiDraggable v-model="originList" class="svoi-images-list" :class="classes">
    <template #item="{ element: file, id }">
      <div :key="id" class="preview-image">
        <div v-if="!disabled" class="button-trash" @click="onClickDeleteFile(file)">
          <SvoiIcon icon="essential/trash" size="s" />
        </div>
        <img class="image" :src="file.path" alt="image" />
        <div class="banner">Основное изображение</div>
      </div>
    </template>
  </SvoiDraggable>
</template>

<script lang="ts">
import type { ComponentPropsOptions, PropType } from 'vue-demi'
import { computed, defineComponent, isVue2 } from 'vue-demi'
import { SvoiIcon } from '@svoi-ui/components/icon'
import type { FileData } from '@svoi-ui/interfaces/file-picker'
import { isFile } from '@svoi-ui/shared/utils/guards'
import { uuid } from '@svoi-ui/shared/utils/helpers'
import { SvoiDraggable } from './'

const modelProp: ComponentPropsOptions = isVue2
  ? {
      value: {
        type: Array as PropType<Array<File | FileData>>,
        default: [] as Array<File | FileData>
      }
    }
  : {
      modelValue: {
        type: Array as PropType<Array<File | FileData>>,
        default: [] as Array<File | FileData>
      }
    }

export default defineComponent({
  name: 'SvoiImagesList',
  components: { SvoiDraggable, SvoiIcon },
  props: {
    ...modelProp,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'on-delete-file', 'update:modelValue'],
  setup(props, { emit }) {
    // @ts-expect-error
    const propValue = computed<Array<File | FileData>>(() => (isVue2 ? props.value : props.modelValue))
    const classes = computed(() => ({
      '-disabled': props.disabled
    }))

    const convertToFileData = (file: File): FileData => {
      return {
        id: uuid(),
        name: file.name,
        path: URL.createObjectURL(file),
        origin: file
      }
    }

    const originList = computed({
      get: () => propValue.value,
      set: val => {
        if (!props.disabled) {
          emit(isVue2 ? 'input' : 'update:modelValue', val)
        }
      }
    })
    const list = computed(() => propValue.value.map(i => (isFile(i) ? convertToFileData(i) : i)))

    const onClickDeleteFile = (file: FileData) => {
      if (!props.disabled) {
        emit('on-delete-file', file.origin ?? file)
      }
    }

    return { list, originList, classes, onClickDeleteFile }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/list.scss';
</style>
